/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_More_OptionsInputs */



/**
* | output |
* | --- |
* | "More Options" |
*
* @param {Dialogue_List_Export_More_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_more_options = /** @type {((inputs?: Dialogue_List_Export_More_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_More_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plus d'options")
	if (locale === "de") return /** @type {LocalizedString} */ ("Weitere Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altre opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дополнительные варианты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más opciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更多选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("その他のオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिक विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mais opções")
	return /** @type {LocalizedString} */ ("More Options")
});